// @ts-nocheck
import {
    getfailedToLoadLedgers,
    getLedgerDocumentTypes,
    getLedgersDataView,
    getLedgerStatuses,
} from "@store/Framework/Store/Store/Data/Ledgers/LedgersSelectors";
import convertSelectorToHook from "@toolkit/Framework/Common/Utilities/convertSelectorToHook";

export const useLedgersDataView = convertSelectorToHook(getLedgersDataView);
export const useLedgerDocumentTypes = convertSelectorToHook(getLedgerDocumentTypes);
export const useLedgerStatuses = convertSelectorToHook(getLedgerStatuses);
export const useFailedToLoadLedgers = convertSelectorToHook(getfailedToLoadLedgers);
